export default __webpack_public_path__ + "static/media/Lock.1125e631.png";